<template>
  <span>
    <label class="custom-label">Select {{ placeholder }}</label>
    <v-autocomplete
      v-model="selected_student"
      :items="users"
      :label="placeholder"
      :placeholder="placeholder"
      @change="emitData"
      item-text="full_name"
      :item-value="type == 'student' ? 'std_id' : 'tutor_id'"
      solo
    >
    </v-autocomplete>
  </span>
</template>

<script>
export default {
  name: "student-report-user-list",
  data() {
    return {
      placeholder: "Student",
      selected_student: 1,
      users: [],
    };
  },
  props: {
    type: {
      default: "student",
    },
  },

  methods: {
    emitData() {
      this.$emit("selectedUserid", this.selected_student);
    },
    getUserList() {
      axios
        .get(
          this.type == "student"
            ? apiRoutes.reports.getStudentList
            : apiRoutes.reports.getTutorList
        )
        .then((response) => {
          this.users = response.data.response;
        });
    },
  },
  mounted() {
    this.placeholder = this.type == "student" ? "Student" : "Teacher";
    this.getUserList();
  },
};
</script>
